export const EnvVars = {
  API: process.env.NEXT_PUBLIC_APP_API_URL,
  NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
};
